import { IRoute } from "@src/routes";
import OutSystensPage from "./pages/OutSystensPage";
import ActivateCard from "./pages/ActivateCard";

const routes: IRoute[] = [
  {
    path: "/benefits/multi",
    key: "BENEFITS_MUILT",
    exact: true,
    component: OutSystensPage,
  },
  {
    path: "/benefits/multi/activate-card",
    key: "BENEFITS_MUILT_ACTIVATE",
    exact: true,
    component: ActivateCard,
  },
];

export default routes;
